<template>
  <div id="app" :class="{ container : isLoginPage }">
    <div id="page">
      <!-- v-if="!this.$route.name == 'login'" -->
      <Header v-if="isLoginPage"></Header>
      
      <router-view></router-view>

    </div>

  </div>
</template>

<script>
  import Header from './components/layouts/Header'

export default {
  name: 'app',
  components: {
    Header,
  },
  data () {
    return {
      loginP: '',
      // msg: 'Welcome to Your Vue.js App'
    }
  },
  created() {
    console.log(this.$route.name)
  },
  computed: {
    isLoginPage() {
      return this.$route.name == 'login' ? false : true
    }
    // loggedIn() {
    //   return this.$store.getters.loggedIn
    // }
    
  },


}
</script>

<style >

  /*==================GENERAL ======================*/
    body {
    overflow: auto;
}
.color-blue {
  color:#006886!important;
}
  body {
    font-family: 'Montserrat', sans-serif!important;
    font-size: 13px;
  }
.c-pointer {
  cursor: pointer;
}
.overflow-none {
  overflow:none; 
}
  img {
    max-width: 100%;
  }
  body {
    background:#fbfbfb;
  }
  button:hover {
      cursor:pointer;
  }
  .page-content-wrap {
    padding-left: 220px;
  }

  .uppercase {
    text-transform: uppercase;
  }
  .w100 {
    width: 100%!important;
    margin-left: 0!important;
    margin-bottom: 10px;
  }
  .float-right {
    float: right;
  }
  .float-left {
    float: left;
  }
  .fa-ellipsis-h:before {
    content: "\f141";
  }
  .container{
    max-width: 100%;
  }
  body {
    width: 100%;
    height:96vh;
  }
  a:hover {
    text-decoration: none;
  }
  li {
    list-style: none;
    font-size:15px;
  }
  .ml0 {
    margin-left: 0;
  }
  .pb10 {
    padding-bottom: 10px;

  }
  .p-absolute {
    position: absolute;
  }
  .pb15 {
    padding-bottom: 20px;
  }
  .pb20 {
    padding-bottom: 20px;
  }
  .mb25 {
    margin-bottom: 25px;
  }
  .mb30 {
    margin-bottom: 30px;
  }
  h5 {
    color:#4b4b4b;
    font-size: 13px;
  }
  ul {
    padding:0;
  }
  .text-right {
    text-align: right;
  }
  .block {
    display: block;
  }
/*  .success-button.active-success-button {
    border: 2px solid #1473e6;
    background: #1473e6 !important;
    color: #fff;
    border-radius: 19px;
    padding: 4px 10px 6px;
    font-weight: 500;
    font-size: 14px;
    margin-left: 15px;
  }*/
  .color-grey {
    color:#707070;
  }
/*SPINNER*/


/*SLIDER*/
.stage-ibx__point:after {
    content: attr(data-nr);
    position: absolute;
    left: 0;
    top: 0;
    width: 10px;
    height: 10px;
    margin-left: -5px;
    margin-top: -5px;
    background: rgba(255, 99, 99, 0.55);
    box-shadow: 0 0 0 3px #fff;
    border-radius: 50%;
    -webkit-transition: box-shadow .2s ease-out, -webkit-transform .2s ease-out;
    transition: box-shadow .2s ease-out, transform .2s ease-out;
}

.stage-ibx__point:hover:after {
    box-shadow: 0 0 0 5px #fff, 0 4px 10px #000;
    -webkit-transform: scale(1.4);
    -ms-transform: scale(1.4);
    transform: scale(1.4);
}

.stage-ibx__point[data-title]:before {
    content: attr(data-title);
    position: absolute;
    bottom: 100%;
    left: 50%;
    min-width: 100px;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, .9);
    color: #fff;
    font-size: 12px;
    line-height: 1.4;
    padding: 6px 3px;
    text-align: center;
    border-radius: 3px;
    margin-bottom: 30px;
    opacity: 0;
    transition: opacity .2s ease-out .1s, visibility .2s ease-out .1s, margin-bottom .2s ease-out .1s;
    z-index: 1;
}
.stage-ibx__point[data-title]:hover:before {
    opacity: 1;
    margin-bottom: 20px;
}
textarea {
  outline:0;:focus{outline: 0;}
}

/***************** SPINER ********************/
.cbx:checked + .check svg {
  stroke: #4285f4;
}
.cbx:checked + .check svg path {
  stroke-dashoffset: 60;
  transition: all 0.3s linear;
}
.cbx:checked + .check svg polyline {
  stroke-dashoffset: 42;
  transition: all 0.2s linear;
  transition-delay: 0.15s;
}
.breadcrumbs li span {
  font-size: 12px!important;
  color:#1473e6 !important;
}
.lds-dual-ring {
  display: inline-block;
  width: 64px;
  height: 64px;
      position: absolute;
    left: 45%;
    top: 40vh;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 46px;
  height: 46px;
  margin: 1px;
  border-radius: 50%;
  border: 5px solid #fff;
     border-color: #006886 transparent #006886 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.input-page-number {
  width: 25px;
  border-radius: 3px;
  border:1px solid #ccc;
  height: 18px;
  padding: 0 8px;

}
.color-checked {
  color:#1473e6 !important;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/App.vue